import jwtAuthAxios from "./auth/jwtAuth";

const pluginServices = {};

pluginServices.getPlugins = async (params) => {
    const { data } = await jwtAuthAxios.get(`/plugins${params}`);
    return data;
};

pluginServices.togglePluginInstallation = async (id) => {
    const { data } = await jwtAuthAxios.post(`/plugins/${id}/toggle_installation`);
    return data;
};

pluginServices.togglePluginActivation = async (id) => {
    const { data } = await jwtAuthAxios.post(`/plugins/${id}/toggle_activation`);
    return data;
};

pluginServices.saveConfig = async (id, params) => {
    const { data } = await jwtAuthAxios.post(`/plugins/${id}/set_config`, params);
    return data;
};

// Prueba en vivo contra el proveedor (la misma de Estado de integraciones). Devuelve
// { ok, level: 'ok' | 'warning' | 'error' | 'info' | 'off', message, checked_at }.
pluginServices.checkConnection = async (id) => {
    const { data } = await jwtAuthAxios.post(`/plugins/${id}/check_connection`, {}, { timeout: 60000 });
    return data;
};

pluginServices.getMeliAccounts = async () => {
    const { data } = await jwtAuthAxios.get(`/meli/accounts`);
    return data;
};

pluginServices.disconnectMeliAccount = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/meli/accounts/${id}`);
    return data;
};

// ===== Shopify =====

pluginServices.getShopifyShops = async () => {
    const { data } = await jwtAuthAxios.get(`/shopify/shops`);
    return data;
};

pluginServices.getShopifyInstallUrl = async (shop) => {
    const { data } = await jwtAuthAxios.get(`/shopify/oauth/install`, { params: { shop } });
    return data; // { authorize_url: "..." }
};

pluginServices.saveShopifyCredentials = async ({ client_id, client_secret }) => {
    const { data } = await jwtAuthAxios.put(`/shopify/credentials`, { client_id, client_secret });
    return data;
};

// { fulfill_on_prepared, push_trigger_state, notify_customer_on_fulfillment, mark_delivered,
//   mark_delivered_scope }, cualquiera
pluginServices.saveShopifySettings = async (settings) => {
    const { data } = await jwtAuthAxios.put(`/shopify/settings`, settings);
    return data;
};

pluginServices.disconnectShopifyShop = async (domain) => {
    const { data } = await jwtAuthAxios.delete(`/shopify/shops/${encodeURIComponent(domain)}`);
    return data;
};

// ===== Bsale =====
//
// Una sola cuenta por company: el access_token de Bsale es por empresa, asi que no
// hay lista de cuentas que listar ni desconectar como en Mercado Libre.

pluginServices.getBsaleConnection = async () => {
    const { data } = await jwtAuthAxios.get(`/bsale/connection`);
    return data;
};

// El backend prueba el token contra Bsale y solo lo guarda si responde, asi que un
// 422 aca significa que el token no sirve y que no se piso el que estaba.
pluginServices.connectBsale = async (accessToken) => {
    const { data } = await jwtAuthAxios.post(`/bsale/connection`, { access_token: accessToken });
    return data;
};

pluginServices.saveBsaleDocumentTypes = async (documentTypeIds) => {
    const { data } = await jwtAuthAxios.put(`/bsale/document_types`, { document_type_ids: documentTypeIds });
    return data;
};

// Guardado parcial a proposito: se manda solo la mitad que se edito, y el backend
// no toca la otra.
pluginServices.saveBsaleChannels = async (payload) => {
    const { data } = await jwtAuthAxios.put(`/bsale/channels`, payload);
    return data;
};

export default pluginServices;
